import { useCallback } from 'react';

import { fetchTopVacancies } from '../../../services';
import { VacanciesResponseInterface } from '../../../types/vacancies.types';
import { ApiServiceType, useApiService } from '../useApiService';
import { useVacanciesLinkTransformer } from '../useVacanciesLinkTransformer';

import { FetchTopVacanciesHookType } from './useFetchTopVacancies.types';

export const useFetchTopVacancies: FetchTopVacanciesHookType = ({ immediateExecute } = {}) => {
  const service: ApiServiceType<object, VacanciesResponseInterface> = useCallback(
    ({ abortController } = {}) => fetchTopVacancies(abortController),
    []
  );
  const linkTransformer = useVacanciesLinkTransformer();

  const serviceResult = useApiService<object, VacanciesResponseInterface>({
    service,
    responseTransformers: linkTransformer,
    immediateExecute,
  });

  return {
    ...serviceResult,
    topVacancies: serviceResult.response?.vacancies ?? [],
    fetchTopVacancies: serviceResult.executeCall,
  };
};
